import React from "react";
import { FolderFill } from "react-bootstrap-icons";

import "./NoData.scss";

type NoDataProps = {
  visible: boolean;
  description?: string;
};

export const NoData = ({ visible, description }: NoDataProps) => (
  <>
    {visible
                && (
                  <div className="no-data">
                    <div className="icon-circle">
                      <FolderFill size={40} />
                    </div>
                    <div className="description">
                      { description || "No Data" }
                    </div>
                  </div>
                )}
  </>
);
